import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    api
      .post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } })
      .then(({ data }) => {
        try { if (data?.token) localStorage.setItem("scorppath_token", data.token); } catch { /* ignore */ }
        setUser(data);
        navigate("/dashboard", { replace: true });
      })
      .catch(() => {
        navigate("/login", { replace: true });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F9F8]" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-3 text-[#114A31]">
        <Loader2 className="h-8 w-8 animate-spin" />
        <p className="font-body text-sm text-[#595D5A]">Signing you in…</p>
      </div>
    </div>
  );
}
